export default {
  routes: [
    /*  登录页 */
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/login/index.vue"),
    },

    /* 管理端 */
    {
      path: "/management",
      name: "Management",
      component: () => import("@/view/management/index.vue"), //导航
      // redirect: "/management/supAdmin", //重定向到第一个子路由
      children: [
        /* 欢迎页*/
        {
          path: "welcome",
          name: "Welcome",
          component: () => import("@/view/management/welcome/index.vue"),
        },
        /* 超级管理员-管理账号权限 */
        {
          path: "systemPage",
          name: "SystemPage",
          component: () => import("@/view/management/systemPage/index.vue"),
          children: [{
            path: "account",
            name: "Account",
            component: () =>
              import("@/view/management/systemPage/account/index.vue"),
          },
          ],
        },
        /* 门店管理模块 */
        {
          path: "storeConfig",
          name: "StoreConfig",
          component: () => import("@/view/management/storeConfig/index.vue"),
          children: [
            {
              path: "storeInfo",
              name: "StoreInfo",
              component: () =>
                import("@/view/management/storeConfig/storeInfo/index.vue"),
            },
            {
              path: "storeAccountMapping",
              name: "StoreAccountMapping",
              component: () =>
                import("@/view/management/storeConfig/storeAccountMapping/index.vue"),
            },
          ],
        },
        /* 我的门店管理 */
        {
          path: "myStorePage",
          name: "MyStorePage",
          component: () => import("@/view/management/myStorePage/index.vue"),
          children: [
            {
              path: "bannerConfig",
              name: "StoreBannerConfig",
              component: () =>
                import("@/view/management/myStorePage/bannerConfig/index.vue"),
            },
            {
              path: "goodsKind",
              name: "StoreGoodsKind",
              component: () =>
                import("@/view/management/myStorePage/goodsKind/index.vue"),
            },
            {
              path: "goodsList",
              name: "StoreGoodsList",
              component: () =>
                import("@/view/management/myStorePage/goodsList/index.vue"),
            },
            {
              path: "appointmentList",
              name: "AppointmentList",
              component: () =>
                import("@/view/management/myStorePage/appointmentList/index.vue"),
            },
            //   {
            //   path: "storeList",
            //   name: "MyStoreStoreList",
            //   component: () =>
            //     import("@/view/management/myStore/storeList/index.vue"),
            // },
            // {
            //   path: "staff",
            //   name: "Staff",
            //   component: () =>
            //     import("@/view/management/myStore/staff/index.vue"),
            // },
          ],
        },

        /* 微商城 */
        {
          path: "goodsMall",
          name: "GoodsMall",
          component: () =>
            import("@/view/management/goodsMall/index.vue"),
          children: [{
            path: "goodsKind",
            name: "GoodsMallKind",
            component: () =>
              import(
                "@/view/management/goodsMall/goodsKind/index.vue"
              ),
          },
          {
            path: "goodsList",
            name: "GoodsMallList",
            component: () =>
              import(
                "@/view/management/goodsMall/goodsList/index.vue"
              ),
          },
          ],
        },

        /* 积分商城 */
        // {
        //   path: "integralGoods",
        //   name: "IntegralGoods",
        //   component: () =>
        //     import("@/view/management/integralGoods/index.vue"),
        //   children: [{
        //     path: "goodsKind",
        //     name: "IntegralGoodsKind",
        //     component: () =>
        //       import(
        //         "@/view/management/integralGoods/goodsKind/index.vue"
        //       ),
        //   },
        //   {
        //     path: "goodsList",
        //     name: "IntegralGoodsList",
        //     component: () =>
        //       import(
        //         "@/view/management/integralGoods/goodsList/index.vue"
        //       ),
        //   },
        //   ],
        // },

        /* 会员管理 */
        {
          path: "vipCardPage",
          name: "vipCardPage",
          component: () => import("@/view/management/vipCardPage/index.vue"),
          children: [{
            path: "vipCardList",
            name: "VipCardList",
            component: () => import("@/view/management/vipCardPage/vipCardList"),
          },
          {
            path: "vipCardRecode",
            name: "VipCardRecode",
            component: () =>
              import("@/view/management/vipCardPage/vipCardRecode"),
          },
          ],
        },

        /* 订单 */
        {
          path: "orderPage",
          name: "OrderPage",
          component: () => import("@/view/management/orderPage/index.vue"),
          children: [{
            path: "appointmentOrder",
            name: "AppointmentOrder",
            component: () =>
              import("@/view/management/orderPage/appointmentOrder/index.vue"),
          }, {
            path: "storeOrder",
            name: "StoreOrder",
            component: () =>
              import("@/view/management/orderPage/storeOrder/index.vue"),
          }, {
            path: "mallOrder",
            name: "MallOrder",
            component: () =>
              import("@/view/management/orderPage/mallOrder/index.vue"),
          },
          ],
        },

        /* 商家服务 */
        // {
        //   path: "merchant",
        //   name: "Merchant",
        //   component: () => import("@/view/management/merchant/index.vue"),
        //   children: [{
        //     path: "payment",
        //     name: "Payment",
        //     component: () =>
        //       import("@/view/management/merchant/payment/index.vue"),
        //   },],
        // },
        /* 个人页 */
        {
          path: "personCenter",
          name: "PersonCenter",
          component: () => import("@/view/management/personCenter/index.vue"), //导航
        }
      ],
    },
    /* 其他页 */
    {
      path: "/error",
      name: "Error",
      component: () => import("@/view/error/index.vue"),
    },
  ],
  // mode: "history",
  mode: "hash",
};